import { ProfileItem } from "PFApp/components/profile_item";
import { getProfileName } from "PFCore/helpers/profile";
import { fetchProfilesOptions } from "PFCore/services/profile";
import { PermissionRule } from "PFTypes";

import css from "./exception_modal_content.module.scss";

export const fetchOptions = async ({ ids, searchTerm }) => {
  const response = await fetchProfilesOptions({
    value: ids,
    term: searchTerm,
    profileVisibility: "active",
    policyName: PermissionRule.AuditApprover
  });
  const options = (response.entries ?? []).map((entry) => ({
    id: entry.id,
    value: getProfileName(entry),
    displayElement: <ProfileItem profile={entry} classes={{ content: css.profileItemContent }} />,
    original: entry
  }));

  return {
    ...response,
    entries: options
  };
};
